import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Messagetype } from '../Shared/model/enum';
import { HttpStatusCode, ResponseModel } from '../Shared/model/response.model';
import { GetSetService } from '../Shared/services/getset.serverce';
import { AppService } from '../Shared/services/app.service';
import { ApiDataService } from '../Shared/services/apidata.service';
import { ToastService } from '../Shared/services/toast.service';
import { IAddress } from '../Shared/model/address.model';
import { ICity } from '../Shared/model/city.model';
import { IAreabyCity } from '../Shared/model/area.model';
import { DropdownService } from '../Shared/services/dropdown.service';



@Component({
  selector: 'app-address',
  templateUrl: 'address.component.html',
  styleUrls: ['address.component.scss']
})
export class AddressComponent implements OnInit {

  @ViewChild('cancelmodel') cancelmodel?: ElementRef;

  @Input() selectedAddress: number = 0;
  @Input() fromAccont: boolean = false;



  @Output() onselected = new EventEmitter();

  showaddress = true;
  saveloader = false;

  addreshForm: FormGroup;
  submitted = false;
  adresess: IAddress[] = [];
  selectedadreses?: IAddress;
  addressId = 0;
  areaname = '';
  isDefaultChecked = false;
  city:any;

  cityList: ICity[] = [];
  copyOfDefaulAddress: any;
  addressTypeId = 1;
  // addressTypeId :any;
  disableSaveBtn = false;
  areaList: IAreabyCity[] = [];
  areaListofSelectedPinCode: Array<any> = [];

  postcodeList: any[] = [];
  postcodeListofSelectedPinCode: Array<any> = [];


  constructor(
    private apidataservice: ApiDataService,
    private getSetService: GetSetService,
    private appservice: AppService,
    private apiservice: ApiDataService,
    private formBuilder: FormBuilder,
    private toastService: ToastService,
    private dropdownService: DropdownService,


  ) {
    this.addreshForm = this.formBuilder.group({
      houseNo: ['', Validators.required],
      appartment: ['', Validators.required],
      streetDetails: ['', Validators.required],
      landmark: ['', Validators.required],
      // cityId: ['', Validators.required],
      city: ['', Validators.required],
      pincode: ['', Validators.required],
      area: ['', Validators.required],
      isDefault: [false],
      mobileNo: ['', Validators.required]

    });
  }

  get f() { return this.addreshForm.controls; }

  ngOnInit(): void {
    // this.getCityList();
    this.getUserDefaultAddress(false);
  }

  resetForm() {
    this.submitted = false;
    this.addreshForm.reset();
  }

  public getUserDefaultAddress(makeselectedLatest: boolean) {
    const url = `UserAddress/MyAddress`;
    this.apidataservice
      .getData(url)
      .subscribe((response: ResponseModel<any>) => {
        // console.log(response);
        if (response.status === HttpStatusCode.OK) {
          this.adresess = response.data.userAddress;
          this.selectedadreses = this.adresess.find(m => m.isdefault);

          if (makeselectedLatest) {
            this.selectedadreses = this.adresess[0];
          }
          this.onselected.emit(this.selectedadreses);

          if (this.adresess.length > 1) {
            this.showaddress = false;
          }
        }
        else {
          if(!this.fromAccont){
            this.toastService.showToast(Messagetype.fail, 'info', `Please Enter Address...!`);
          }
        }
      });
  }

  // getCityList() {
  //   const url = `City/GetCityList?pageSize=0&pageNumber=0`;
  //   this.apiservice.getData(url).subscribe
  //     ((response: ResponseModel<any>) => {
  //       if (response.status === HttpStatusCode.OK) {
  //         this.cityList = response?.data;
  //       }
  //     });
  // }

  // getAreaListByCity(cityId: number,) {
  //   const url = `Area/GetAreaListByCityId?CityId=${cityId}`;
  //   this.apiservice.getData(url).subscribe
  //     ((response: ResponseModel<any>) => {
  //       if (response.status === HttpStatusCode.OK) {
  //         this.areaList = response?.data;
  //         this.areaListofSelectedPinCode = [];
  //       } else {
  //         this.areaList = [];
  //       }
  //     });
  // }


  GetAreaListByPincode(pincode: number,) {
    const url = `UserAddress/GetAreaListByPincode?pincode=${pincode}`;
    this.apiservice.getData(url).subscribe
      ((response: any) => {
        if (response.status === HttpStatusCode.OK) {
          this.postcodeList = response?.data.postcode_details.locality;
          this.city = response.data.postcode_details.city;
        } else {
          this.postcodeList = [];
        }
      });
  }


  filterAreaByPincode(pincode: string) {
    if (pincode.length === 6) {
      const result = this.postcodeList.map((a) => {
        if(a.pinCode === pincode){
          // return a;
        }
      });

      this.postcodeListofSelectedPinCode = this.postcodeList.filter( a => a.pinCode === pincode);

      this.postcodeListofSelectedPinCode = [];
      if (result) {
        this.postcodeList.forEach((area) => {
          if (area.pinCode === pincode) {
            this.postcodeListofSelectedPinCode.push(area);
            this.toastService.showToast(Messagetype.sucess, 'Info', 'Service is availabe start shoping');

          }
        });
      } else {
        this.toastService.showToast(Messagetype.fail, 'Info', `Enter valid pincode or Service is not availble for ${pincode} pincode`);

      }

    }
  }


  getCityName(cityId: number): string {
    const city = this.cityList.find(m => m.id == cityId);
    if (city) {
      return city.cityNameEng;
    }
    return '';
  }


  getAreaName(areaId: number): string {
    const area = this.areaList.find(m => m.id == areaId);
    if (area) {
      return area.areaNameEng;
    }
    return '';
  }

  onSelectDefaultAddress(event: any){
    this.isDefaultChecked  = event.target.checked;
  }

  public addNewAddress() {

    this.submitted = true;

    const cityId = +this.addreshForm.value.cityId;
    const areaId = +this.addreshForm.value.area;

    const city = this.getCityName(+cityId);
    const area = this.getAreaName(areaId);

    if (this.addreshForm.valid) {
      this.saveloader = true;
      const data: IAddress = {
        id: this.addressId,
        houseNo: this.addreshForm.value.houseNo,
        appartmentName: this.addreshForm.value.appartment,
        streetDetails: this.addreshForm.value.streetDetails,
        landmark: this.addreshForm.value.landmark,
        // cityId: cityId,
        // areaId: areaId,
        cityId: 0,
        areaId: 0,
        mobileNo: this.addreshForm.value.mobileNo,
        areaName: this.addreshForm.value.area,
        city: this.addreshForm.value.city,
        pincode: this.addreshForm.value.pincode,
        addressType: this.addressTypeId,
        niknameAddress: "",
        isdefault: this.isDefaultChecked,
        // isdefault: this.addreshForm.value.isDefault,
        latitude: "string",
        longitude: "string",
        areaCode: '',
        placeId: "",
        isMobileExists: true
      };


      let url = '';
      if (this.addressId === 0) {
        url = `UserAddress/AddUserAddress`;
      } else {
        url = `UserAddress/UpdateUserAddress`;
      }
      this.apidataservice
        .postData(url, data)
        .subscribe((response: ResponseModel<any>) => {
          if (response.status === HttpStatusCode.OK) {
            if (this.addressId === 0) {
              this.toastService.showToast(Messagetype.sucess, 'Info', 'Address added');
            } else {
              this.toastService.showToast(Messagetype.sucess, 'Info', 'Updated address');
            }
            this.addressId = 0;
            this.isDefaultChecked=false;
            this.getUserDefaultAddress(true);
            this.closepopup();
          } else {
            this.toastService.showToast(Messagetype.fail, 'Info', `${response.statusMessage}`);
            // this.addressId = 0;
          }

          this.saveloader = false;
        });
    }
  }

  editAddress(address: IAddress) {
    this.copyOfDefaulAddress = address;
    this.GetAreaListByPincode(Number(address.pincode));
    this.addressId = address.id;
    this.addreshForm.controls.houseNo.setValue(address.houseNo);
    this.addreshForm.controls.appartment.setValue(address.appartmentName);
    this.addreshForm.controls.streetDetails.setValue(address.streetDetails);
    this.addreshForm.controls.landmark.setValue(address.landmark);
    // this.addreshForm.controls.cityId.setValue(address.cityId);
    this.addreshForm.controls.pincode.setValue(address.pincode);
    this.addreshForm.controls.city.setValue(address.city);
    this.addreshForm.controls.mobileNo.setValue(address.mobileNo);
    this.addreshForm.controls.area.setValue(address.areaName);
    this.addreshForm.controls.isDefault.setValue(address.isdefault);
    this.isDefaultChecked=address.isdefault

    this.areaname = address.areaName;
    // this.setArea(address);

    this.addressTypeId = address.addressType;
    // this.disableSaveBtn = true;
  }

  // public setArea(address: IAddress){
  //   const url = `Area/GetAreaListByCityId?CityId=${+address.cityId}`;
  //   this.apiservice.getData(url).subscribe
  //     ((response: ResponseModel<any>) => {
  //       if (response.status === HttpStatusCode.OK) {
  //         this.areaList = response?.data;
  //         this.areaListofSelectedPinCode = this.areaList.filter( a => a.pinCode === address.pincode);
  //         this.addreshForm.controls.area.setValue(address.areaId);
  //       } else {
  //         this.areaList = [];
  //       }
  //     });
  // }

  deleteAddresh(id: number) {
    const url = `UserAddress/DeleteUserAddress?Id=${id}`;
    this.apidataservice.postData(url, '').subscribe
      ((response: ResponseModel<any>) => {
        if (response.status === HttpStatusCode.OK) {
          this.toastService.showToast(Messagetype.sucess, 'Info', 'Deleted address');
          this.getUserDefaultAddress(false);
        }
      });
  }


  selectType(id: number): void {
    this.addressTypeId = id;
  }


  selectAddress(address: IAddress) {
    this.selectedadreses = address;
    this.onselected.emit(address);
  }

  closepopup() {
    // if (this.cancelmodel) {
    //   this.cancelmodel.nativeElement.click();
    // }
    document.getElementById('cancelmodel')?.click();
  }

  isNumber(evt: any) {
    evt = evt ? evt : window.event;
    const charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}
